
<div class="container">
    <div class="row my-3">
        <mat-form-field appearance="outline" class="w-50">
            <mat-label>Nom de l'élément</mat-label>
            <input matInput type="text" [(ngModel)]="value"/>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-50">
            <mat-label>Référence de l'élément</mat-label>
            <input matInput type="text" [(ngModel)]="ref" disabled/>
        </mat-form-field>
    </div>
    <div class="row my-3">
        <mat-form-field appearance="outline">
            <mat-label>Type de contenu</mat-label>
            <mat-select [(value)]="contentType">
                <mat-option value="TEXT">Texte et images</mat-option>
                <mat-option value="VIDEO">Vidéo YouTube</mat-option>
                <mat-option value="DOCUMENT">Document (PDF, XLS...)</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="row my-3">
        <app-text-editor *ngIf="isText" #appTextEditor [content]="content"></app-text-editor>

        <div *ngIf="isVideo">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>URL de la video youtube</mat-label>
                <input matInput type="text" [(ngModel)]="videoURL"/>
            </mat-form-field>
        
        </div>
        <div *ngIf="isDocument">
            <mat-form-field class="w-100">
                <input matInput type="file" #fileInput (change)="loadDocument($event)"/>
            </mat-form-field>
        </div>
    </div>
    <div class="row my-3 d-flex justify-content-around">
        <button mat-raised-button class="w-25 btn" (click)="close()">ANNULER</button>
        <button mat-raised-button class="w-25 btn-primary" (click)="validate()">VALIDER</button>
    </div>
</div>